
// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// // Exact-match whitelist for the "Other" issue type
// const OTHER_LABELS = ["other", "others"];

// const WriteToHrApp = () => {
//     const navigate = useNavigate();

//     // ---- state ----
//     const [issueTypes, setIssueTypes] = useState([]);
//     const [selectedType, setSelectedType] = useState(null);
//     const [description, setDescription] = useState("");
//     const [attachment, setAttachment] = useState(null);
//     const [customOtherType, setCustomOtherType] = useState("");
//     const [submitting, setSubmitting] = useState(false);
//     const [dropdownOpen, setDropdownOpen] = useState(false);

//     const fileInputRef = useRef(null);

//     // ---- fetch issue types on mount ----
//     useEffect(() => {
//         const fetchIssueTypes = async () => {
//             try {
//                 const res = await axios.get(
//                     `${process.env.REACT_APP_SERVER_ADDRESS}/common/other/get-issue`,
//                 );
//                 setIssueTypes(res?.data?.data || []);
//             } catch (error) {
//                 console.error("Error fetching issue types:", error);
//             }
//         };
//         fetchIssueTypes();
//     }, []);

//     // ---- computed values ----
//     const selectedItem = issueTypes.find((item) => item.id === selectedType);
//     const isOther = OTHER_LABELS.includes(selectedItem?.name?.toLowerCase());

//     // Sort: put "Other"/"Others" at the bottom
//     const sortedIssueTypes = [...issueTypes].sort((a, b) => {
//         const aIsOther = OTHER_LABELS.includes(a.name?.toLowerCase());
//         const bIsOther = OTHER_LABELS.includes(b.name?.toLowerCase());
//         if (aIsOther === bIsOther) return 0;
//         return aIsOther ? 1 : -1;
//     });

//     // ---- attachment handlers ----
//     const handleFileChange = (e) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         const reader = new FileReader();
//         reader.onloadend = () => {
//             setAttachment({
//                 file,
//                 name: file.name,
//                 type: file.type,
//                 dataURL: reader.result,
//             });
//         };
//         reader.readAsDataURL(file);
//         e.target.value = "";
//     };

//     const removeAttachment = () => {
//         setAttachment(null);
//         if (fileInputRef.current) fileInputRef.current.value = "";
//     };

//     // ---- submit ----
//     const handleSubmit = async () => {
//         if (!selectedType) {
//             alert("Please select an issue type.");
//             return;
//         }
//         if (!description.trim()) {
//             alert("Please describe the issue.");
//             return;
//         }
//         if (isOther && !customOtherType.trim()) {
//             alert("Please specify the custom issue type.");
//             return;
//         }

//         setSubmitting(true);
//         try {
//             const payload = {
//                 issueId: selectedType,
//                 type: isOther ? customOtherType.trim() : selectedItem?.name,
//                 body: description.trim(),
//                 attachments: attachment ? [attachment.dataURL] : [],
//             };

//             await axios.post(
//                 `${process.env.REACT_APP_SERVER_ADDRESS}/common/other/add-feedback`,
//                 payload,
//                 { headers: { "Content-Type": "application/json" } },
//             );

//             alert("Your issue has been sent to HR.");
//             navigate("/layout/emp/Show-your-issue");
//         } catch (error) {
//             console.error("Submit error:", error?.response?.data);
//             alert("Something went wrong. Please try again.");
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     // ---- render dropdown ----
//     const renderDropdown = () => (
//         <div className="relative">
//             <button
//                 type="button"
//                 onClick={() => setDropdownOpen(!dropdownOpen)}
//                 className="w-full flex items-center justify-between px-4 py-3 bg-white border border-gray-300 rounded-xl text-sm text-black focus:outline-none focus:ring-2 focus:ring-yellow-400"
//             >
//                 <span className={selectedItem ? "text-black" : "text-gray-400"}>
//                     {selectedItem ? selectedItem.name : "Choose an issue"}
//                 </span>
//                 <svg
//                     className={`w-5 h-5 text-gray-500 transition-transform ${dropdownOpen ? "rotate-180" : ""}`}
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                 >
//                     <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M19 9l-7 7-7-7"
//                     />
//                 </svg>
//             </button>

//             {dropdownOpen && (
//                 <div className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-xl shadow-lg max-h-60 overflow-y-auto">
//                     {sortedIssueTypes.map((item) => {
//                         const isSelected = selectedType === item.id;
//                         return (
//                             <button
//                                 key={item.id}
//                                 onClick={() => {
//                                     setSelectedType(item.id);
//                                     setDropdownOpen(false);
//                                     if (
//                                         !OTHER_LABELS.includes(
//                                             item.name.toLowerCase(),
//                                         )
//                                     ) {
//                                         setCustomOtherType("");
//                                     }
//                                 }}
//                                 className={`w-full text-left px-4 py-3 text-sm hover:bg-yellow-50 transition ${
//                                     isSelected
//                                         ? "bg-yellow-100 text-black font-semibold"
//                                         : "text-gray-800"
//                                 }`}
//                             >
//                                 {item.name}
//                             </button>
//                         );
//                     })}
//                 </div>
//             )}
//         </div>
//     );

//     // ---- main ----
//     return (
//         <div className="min-h-screen bg-gray-100 py-6 px-4 md:px-8 lg:px-12 font-sans">
//             <div className="max-w-3xl mx-auto">
//                 {/* Header */}
//                 <div className="flex items-center gap-3 mb-6">
//                     <button
//                         onClick={() => navigate(-1)}
//                         className="w-9 h-9 flex items-center justify-center bg-white rounded-full shadow-sm text-lg hover:bg-gray-100 transition text-black"
//                     >
//                         <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             className="h-6 w-6"
//                             fill="none"
//                             viewBox="0 0 24 24"
//                             stroke="currentColor"
//                             strokeWidth={2}
//                         >
//                             <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 d="M15 19l-7-7 7-7"
//                             />
//                         </svg>
//                     </button>
//                     <div>
//                         <h1 className="text-2xl font-bold text-black">
//                             Write to HR
//                         </h1>
//                         <p className="text-sm text-gray-600">
//                             All messages are sent to HR directly.
//                         </p>
//                     </div>
//                 </div>

//                 {/* Form Card */}
//                 <div className="bg-white rounded-2xl shadow-md p-6 md:p-8 space-y-6 border border-gray-200">
//                     {/* Issue type */}
//                     <div>
//                         <label className="block text-sm font-semibold text-black mb-1">
//                             Select issue type
//                         </label>
//                         {renderDropdown()}
//                     </div>

//                     {/* Custom type input (only for "Other") */}
//                     {isOther && (
//                         <div>
//                             <label className="block text-sm font-semibold text-black mb-1">
//                                 Specify your issue type
//                             </label>
//                             <input
//                                 type="text"
//                                 placeholder="e.g., Payroll, Equipment, etc."
//                                 value={customOtherType}
//                                 onChange={(e) =>
//                                     setCustomOtherType(e.target.value)
//                                 }
//                                 className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-400"
//                             />
//                         </div>
//                     )}

//                     {/* Description */}
//                     <div>
//                         <label className="block text-sm font-semibold text-black mb-1">
//                             Describe the issue
//                         </label>
//                         <textarea
//                             rows={4}
//                             placeholder="Tell HR what happened…"
//                             value={description}
//                             onChange={(e) => setDescription(e.target.value)}
//                             className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm text-black placeholder-gray-400 resize-none focus:outline-none focus:ring-2 focus:ring-yellow-400"
//                         />
//                     </div>

//                     {/* Attachment */}
//                     <div>
//                         <label className="block text-sm font-semibold text-black mb-1">
//                             Attachment (optional)
//                         </label>
//                         <div className="flex flex-wrap gap-3">
//                             <button
//                                 onClick={() => fileInputRef.current?.click()}
//                                 className="flex items-center gap-2 px-4 py-2.5 bg-yellow-400 hover:bg-yellow-500 rounded-xl text-sm font-medium text-black transition"
//                             >
//                                 <span>📎</span> Choose file
//                             </button>
//                             <input
//                                 ref={fileInputRef}
//                                 type="file"
//                                 accept="image/*,.pdf,.doc,.docx,.txt"
//                                 onChange={handleFileChange}
//                                 className="hidden"
//                             />
//                             {attachment && (
//                                 <button
//                                     onClick={removeAttachment}
//                                     className="flex items-center gap-1 px-4 py-2.5 bg-red-50 hover:bg-red-100 rounded-xl text-sm font-medium text-red-600 transition"
//                                 >
//                                     <span>✕</span> Remove
//                                 </button>
//                             )}
//                         </div>

//                         {attachment && (
//                             <div className="mt-3 flex items-center gap-3 p-3 bg-gray-50 rounded-xl border border-gray-200">
//                                 {attachment.type?.startsWith("image/") ? (
//                                     <img
//                                         src={attachment.dataURL}
//                                         alt="attachment"
//                                         className="w-16 h-16 object-cover rounded-lg"
//                                     />
//                                 ) : (
//                                     <span className="text-3xl">📄</span>
//                                 )}
//                                 <div className="flex-1 min-w-0">
//                                     <p className="text-sm font-medium text-black truncate">
//                                         {attachment.name}
//                                     </p>
//                                     <p className="text-xs text-gray-500">
//                                         {(attachment.file?.size / 1024).toFixed(
//                                             1,
//                                         )}{" "}
//                                         KB
//                                     </p>
//                                 </div>
//                             </div>
//                         )}
//                     </div>

//                     {/* Submit */}
//                     <button
//                         onClick={handleSubmit}
//                         disabled={submitting}
//                         className={`w-full py-3.5 rounded-xl bg-yellow-400 text-black text-sm font-semibold shadow-sm transition ${
//                             submitting
//                                 ? "opacity-60 cursor-not-allowed"
//                                 : "hover:bg-yellow-500"
//                         }`}
//                     >
//                         {submitting ? "Submitting…" : "Submit to HR"}
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default WriteToHrApp;






import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

// Exact-match whitelist for the "Other" issue type
const OTHER_LABELS = ["other", "others"];

const WriteToHrApp = () => {
    const navigate = useNavigate();

    // ---- state ----
    const [issueTypes, setIssueTypes] = useState([]);
    const [selectedType, setSelectedType] = useState(null);
    const [description, setDescription] = useState("");
    const [attachment, setAttachment] = useState(null);
    const [customOtherType, setCustomOtherType] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const fileInputRef = useRef(null);

    // ---- fetch issue types on mount ----
    useEffect(() => {
        const fetchIssueTypes = async () => {
            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_SERVER_ADDRESS}/common/other/get-issue`,
                );
                // Only show issue types HR has marked active
                const activeOnly = (res?.data?.data || []).filter(
                    (item) => item.isActive === true,
                );
                setIssueTypes(activeOnly);
            } catch (error) {
                console.error("Error fetching issue types:", error);
            }
        };
        fetchIssueTypes();
    }, []);

    // ---- computed values ----
    const selectedItem = issueTypes.find((item) => item.id === selectedType);
    const isOther = OTHER_LABELS.includes(selectedItem?.name?.toLowerCase());

    // Sort: put "Other"/"Others" at the bottom
    const sortedIssueTypes = [...issueTypes].sort((a, b) => {
        const aIsOther = OTHER_LABELS.includes(a.name?.toLowerCase());
        const bIsOther = OTHER_LABELS.includes(b.name?.toLowerCase());
        if (aIsOther === bIsOther) return 0;
        return aIsOther ? 1 : -1;
    });

    // ---- attachment handlers ----
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            setAttachment({
                file,
                name: file.name,
                type: file.type,
                dataURL: reader.result,
            });
        };
        reader.readAsDataURL(file);
        e.target.value = "";
    };

    const removeAttachment = () => {
        setAttachment(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    // ---- submit ----
    const handleSubmit = async () => {
        if (!selectedType) {
            alert("Please select an issue type.");
            return;
        }
        if (!description.trim()) {
            alert("Please describe the issue.");
            return;
        }
        if (isOther && !customOtherType.trim()) {
            alert("Please specify the custom issue type.");
            return;
        }

        setSubmitting(true);
        try {
            const payload = {
                issueId: selectedType,
                type: isOther ? customOtherType.trim() : selectedItem?.name,
                body: description.trim(),
                attachments: attachment ? [attachment.dataURL] : [],
            };

            await axios.post(
                `${process.env.REACT_APP_SERVER_ADDRESS}/common/other/add-feedback`,
                payload,
                { headers: { "Content-Type": "application/json" } },
            );

            alert("Your issue has been sent to HR.");
            navigate("/layout/emp/Show-your-issue");
        } catch (error) {
            console.error("Submit error:", error?.response?.data);
            alert("Something went wrong. Please try again.");
        } finally {
            setSubmitting(false);
        }
    };

    // ---- render dropdown ----
    const renderDropdown = () => (
        <div className="relative">
            <button
                type="button"
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="w-full flex items-center justify-between px-4 py-3 bg-white border border-gray-300 rounded-xl text-sm text-black focus:outline-none focus:ring-2 focus:ring-yellow-400"
            >
                <span className={selectedItem ? "text-black" : "text-gray-400"}>
                    {selectedItem ? selectedItem.name : "Choose an issue"}
                </span>
                <svg
                    className={`w-5 h-5 text-gray-500 transition-transform ${dropdownOpen ? "rotate-180" : ""}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                    />
                </svg>
            </button>

            {dropdownOpen && (
                <div className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-xl shadow-lg max-h-60 overflow-y-auto">
                    {sortedIssueTypes.map((item) => {
                        const isSelected = selectedType === item.id;
                        return (
                            <button
                                key={item.id}
                                onClick={() => {
                                    setSelectedType(item.id);
                                    setDropdownOpen(false);
                                    if (
                                        !OTHER_LABELS.includes(
                                            item.name.toLowerCase(),
                                        )
                                    ) {
                                        setCustomOtherType("");
                                    }
                                }}
                                className={`w-full text-left px-4 py-3 text-sm hover:bg-yellow-50 transition ${
                                    isSelected
                                        ? "bg-yellow-100 text-black font-semibold"
                                        : "text-gray-800"
                                }`}
                            >
                                {item.name}
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );

    // ---- main ----
    return (
        <div className="min-h-screen bg-gray-100 py-6 px-4 md:px-8 lg:px-12 font-sans">
            <div className="max-w-3xl mx-auto">
                {/* Header */}
                <div className="flex items-center gap-3 mb-6">
                    <button
                        onClick={() => navigate(-1)}
                        className="w-9 h-9 flex items-center justify-center bg-white rounded-full shadow-sm text-lg hover:bg-gray-100 transition text-black"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M15 19l-7-7 7-7"
                            />
                        </svg>
                    </button>
                    <div>
                        <h1 className="text-2xl font-bold text-black">
                            Write to HR
                        </h1>
                        <p className="text-sm text-gray-600">
                            All messages are sent to HR directly.
                        </p>
                    </div>
                </div>

                {/* Form Card */}
                <div className="bg-white rounded-2xl shadow-md p-6 md:p-8 space-y-6 border border-gray-200">
                    {/* Issue type */}
                    <div>
                        <label className="block text-sm font-semibold text-black mb-1">
                            Select issue type
                        </label>
                        {renderDropdown()}
                    </div>

                    {/* Custom type input (only for "Other") */}
                    {isOther && (
                        <div>
                            <label className="block text-sm font-semibold text-black mb-1">
                                Specify your issue type
                            </label>
                            <input
                                type="text"
                                placeholder="e.g., Payroll, Equipment, etc."
                                value={customOtherType}
                                onChange={(e) =>
                                    setCustomOtherType(e.target.value)
                                }
                                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-400"
                            />
                        </div>
                    )}

                    {/* Description */}
                    <div>
                        <label className="block text-sm font-semibold text-black mb-1">
                            Describe the issue
                        </label>
                        <textarea
                            rows={4}
                            placeholder="Tell HR what happened…"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm text-black placeholder-gray-400 resize-none focus:outline-none focus:ring-2 focus:ring-yellow-400"
                        />
                    </div>

                    {/* Attachment */}
                    <div>
                        <label className="block text-sm font-semibold text-black mb-1">
                            Attachment (optional)
                        </label>
                        <div className="flex flex-wrap gap-3">
                            <button
                                onClick={() => fileInputRef.current?.click()}
                                className="flex items-center gap-2 px-4 py-2.5 bg-yellow-400 hover:bg-yellow-500 rounded-xl text-sm font-medium text-black transition"
                            >
                                <span>📎</span> Choose file
                            </button>
                            <input
                                ref={fileInputRef}
                                type="file"
                                accept="image/*,.pdf,.doc,.docx,.txt"
                                onChange={handleFileChange}
                                className="hidden"
                            />
                            {attachment && (
                                <button
                                    onClick={removeAttachment}
                                    className="flex items-center gap-1 px-4 py-2.5 bg-red-50 hover:bg-red-100 rounded-xl text-sm font-medium text-red-600 transition"
                                >
                                    <span>✕</span> Remove
                                </button>
                            )}
                        </div>

                        {attachment && (
                            <div className="mt-3 flex items-center gap-3 p-3 bg-gray-50 rounded-xl border border-gray-200">
                                {attachment.type?.startsWith("image/") ? (
                                    <img
                                        src={attachment.dataURL}
                                        alt="attachment"
                                        className="w-16 h-16 object-cover rounded-lg"
                                    />
                                ) : (
                                    <span className="text-3xl">📄</span>
                                )}
                                <div className="flex-1 min-w-0">
                                    <p className="text-sm font-medium text-black truncate">
                                        {attachment.name}
                                    </p>
                                    <p className="text-xs text-gray-500">
                                        {(attachment.file?.size / 1024).toFixed(
                                            1,
                                        )}{" "}
                                        KB
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Submit */}
                    <button
                        onClick={handleSubmit}
                        disabled={submitting}
                        className={`w-full py-3.5 rounded-xl bg-yellow-400 text-black text-sm font-semibold shadow-sm transition ${
                            submitting
                                ? "opacity-60 cursor-not-allowed"
                                : "hover:bg-yellow-500"
                        }`}
                    >
                        {submitting ? "Submitting…" : "Submit to HR"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default WriteToHrApp;